import React, { useState, useEffect } from 'react';
import 'react-phone-input-2/lib/style.css';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { LinearProgress } from '@mui/material';
import style from './preScreening.module.scss';
import { getQuery } from '../../../utils/query';
import colors from '../../../scss/colors';

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 81,
  height: 29,
  padding: 0,
  marginBottom: 16,
  '& .Mui-checked+.MuiSwitch-track': {
    backgroundColor: `${colors.NAVY_BLUE}!important`,
    '&:before': {
      content: '"Yes"'
    },
    '&:after': {
      content: '""'
    }
  },
  '& .MuiSwitch-switchBase.Mui-checked': {
    transform: 'translateX(51px)'
  },
  '& .MuiSwitch-track': {
    borderRadius: 18,
    opacity: '1!important',
    backgroundColor: `${colors.MEDIUM_GREY}!important`,
    '&:before, &:after': {
      color: 'white',
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
      fontFamily: 'Gotham',
      fontStyle: 'normal',
      fontWeight: 325,
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center'
    },
    '&:before': {
      content: '""',
      left: 16
    },
    '&:after': {
      content: '"No"',
      right: 16
    }
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 20,
    height: 20,
    margin: -5,
    color: '#C4C4C4'
  }
}));

function PreScreening(props) {
  const [toggles, setToggle] = useState({});
  const { nextHandle, backHandle, questions } = props;
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const trQuestions = Object.values(questions).reduce((resultArray, question, index) => {
    if (!question) {
      return resultArray;
    }
    resultArray[index] = question;
    return resultArray;
  }, []);

  useEffect(() => {
    if (trQuestions.length === 0) {
      nextHandle(toggles);
    } else {
      const questObj = {};
      trQuestions.forEach((_, index) => {
        questObj[`Answer${index + 1}`] = false;
      });
      setToggle(questObj);
    }
    setSearchParams({ ...getQuery(), pagetype: 'prescreening' });
  }, []);

  return !trQuestions.length ? (
    <LinearProgress style={{ marginTop: 30 }} />
  ) : (
    <div className={style.mainWrapper}>
      <div className={style.mainContent}>
        <h4 className={style.header}>{t('jobs.prescreening')}</h4>
        <h6 className={style.sub_header}>{t('jobs.prescreening_sub_header')}</h6>
        {trQuestions.map((item, index) => (
          <React.Fragment key={`question${index + 1}`}>
            <label className={style.question} htmlFor="question">
              {item}
            </label>
            <div>
              <FormControlLabel
                onChange={(e) => {
                  setToggle({ ...toggles, [`Answer${index + 1}`]: e.target.checked });
                }}
                id={`question${index + 1}`}
                control={<CustomSwitch />}
                label=""
                sx={{
                  marginLeft: '0',
                  marginTop: '10px'
                }}
              />
            </div>
          </React.Fragment>
        ))}
      </div>
      <div className={style.buttonContainer}>
        <button className={style.back_button} onClick={backHandle}>
          {t('common.general.back')}
        </button>
        <button className={style.next_button} onClick={() => {
          nextHandle(toggles);
        }}>
          {t('common.general.submit')}
        </button>
      </div>
    </div>
  );
}

export default PreScreening;
